/* Adjustable Shelf Brackets
    --mountType <string::enum> | ['Surface', 'In Wall', 'Hidden']
    --length <string>
    --loadWeight <float> | pounds
    --minShelfDepth <float> | inches
    --maxShelfDepth <float | inches | ('Good for shelves of depth X" to Y"')
*/
import filters from './filters'
import headers from './headers'
import form from './form'
const name = 'Brackets'
const id = '973QGwiwsUd24OgJG6hG'

export default {
  name,
  id,
  filters,
  headers,
  form
}
